<nav class="sn-plan-steps" aria-label="Steps to buy a plan">
  <ol>
    @for (s of steps; track s.step; let last = $last) {
      <li [class.is-current]="current === s.step" [class.is-done]="isDone(s.step)">
        <button
          type="button"
          class="sn-plan-step"
          [attr.aria-current]="current === s.step ? 'step' : null"
          [attr.data-test]="'plan-step-' + s.step"
          (click)="stepSelect.emit(s.step)"
        >
          <span class="sn-plan-step-num" aria-hidden="true">
            @if (isDone(s.step)) {
              <i class="fas fa-check"></i>
            } @else {
              {{ s.step }}
            }
          </span>
          <span class="sn-plan-step-label">
            {{ s.label }}
            @if (s.optional) {
              <span class="sn-plan-step-optional">(optional)</span>
            }
            @if (isDone(s.step)) {
              <span class="visually-hidden">, done</span>
            }
          </span>
        </button>
        @if (!last) {
          <i class="fas fa-chevron-right sn-plan-step-sep" aria-hidden="true"></i>
        }
      </li>
    }
  </ol>
</nav>
